import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import get from 'lodash.get'
import Styled from 'styled-components'
import Media from 'styled-media-query'
import { transparentize } from 'polished'

import Loader from 'components/Loader'
import CatchGlobalClick from 'components/CatchGlobalClick'
import Dropdown from 'components/Dropdown'
import DropdownList from 'components/DropdownList'
import DropdownListItem from 'components/DropdownListItem'
import Link from 'components/Link'
import Icon from 'components/Icon'

const Container = Styled.div`
  position: relative;
`

const Label = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  position: relative;
  border-radius: ${props => props.theme.radius};
  height: 2rem;
  line-height: 2rem;
  padding: 0 0.5rem;
  margin: 0 -0.5rem;
  min-width: 2.5rem;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: .15s;
  cursor: pointer;
  color: ${props => props.theme.colors.black};

  &:hover, &:focus {
    background: ${props => transparentize(0.9, props.theme.colors.white)};
  }

  ${Media.greaterThan('medium')`
    min-width: 10rem;
  `}
`

const Name = Styled.div`
  display: none;
  padding-right: 1.75rem;
  font-size: 0.85rem;

  ${Media.greaterThan('medium') `
    display: block;
  `}
`

const AccountIcon = Styled.div`
  position: absolute;
  top: calc(50% + 2px);
  right: 0.5rem;
  transform: translateY(-50%);
  font-size: 1.5rem;
  line-height: 1;
  color: ${props => props.theme.colors.color};
`

class Identity extends Component {
  state = {
    isDropdownOpen: false
  }

  handleOpenDropdown = () => {
    this.setState({
      isDropdownOpen: true
    })
  }

  handleCloseDropdown = () => {
    this.setState({
      isDropdownOpen: false
    })
  }

  render() {
    const { loading, displayName } = this.props
    const { isDropdownOpen } = this.state

    if (loading) {
      return <Loader />
    }

    return (
      <Container>
        <Label onClick={this.handleOpenDropdown}>
          <Name data-selector="identity-name">
            {displayName}
          </Name>

          <AccountIcon>
            <Icon liga="account_circle" />
          </AccountIcon>
        </Label>

        {isDropdownOpen &&
          <CatchGlobalClick onClick={this.handleCloseDropdown}>
            <Dropdown placement="bottom" align="right">
              <DropdownList>
                {/*<Link to="/account" onClick={this.handleCloseDropdown}>
                  <DropdownListItem>
                    Account
                  </DropdownListItem>
                </Link> */}

                <Link to="/auth/logout" onClick={this.handleCloseDropdown}>
                  <DropdownListItem>
                    Logout
                  </DropdownListItem>
                </Link>
              </DropdownList>
            </Dropdown>
          </CatchGlobalClick>
        }
      </Container>
    )
  }
}

const query = graphql(gql`
  query Identity {
    viewer {
      user {
        _id
        displayName
      }
    }
  }
  `, {
    options() {
      return {
        fetchPolicy: 'network-only'
      }
    },
    props({ data }) {
      return {
        loading: get(data, 'loading'),
        displayName: get(data, 'viewer.user.displayName')
      }
    }
  }
)

export default compose(
  query
)(Identity)



// WEBPACK FOOTER //
// ./src/components/Identity/index.js